export const getGoogleMapLink = (address: string): string => {
	const urlAddress = encodeURIComponent(address);
	let res = `https://maps.google.com/maps/search/?api=1&query=${urlAddress}`;
	if (typeof window !== 'undefined') {
		if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
			res = `maps://maps.google.com/maps/search/?api=1&query=${urlAddress}`;
		}
	}
	return res;
};
